import { fetcher } from '@commenda/utils';

import { BillingInvoiceHelper } from './billing-invoice-helper';
import { downloadInvoice } from './downloadInvoice';
import type { InvoiceRequest } from './types';

export async function getInvoicePdf(
  request: Readonly<InvoiceRequest>
): Promise<Blob> {
  const useMirror = BillingInvoiceHelper.usesMirror(request);
  const response = useMirror
    ? await fetcher(BillingInvoiceHelper.invoiceUrl(request, 'preview'), {
        method: 'GET',
      })
    : await fetch((await downloadInvoice(request)).downloadUrl);
  if (!response.ok) throw new Error('Could not load the invoice PDF.');
  return new Blob([await response.arrayBuffer()], { type: 'application/pdf' });
}
